// @ts-nocheck
import { Controller } from '@hotwired/stimulus';

export default class DeclineModalController extends Controller {
  static values = {
    reasonRequiredError: String,
    otherReasonRequiredError: String,
  };
  static targets = [
    'form',
    'otherCheckbox',
    'otherReasonField',
    'otherReasonInput',
    'submitBtn',
    'checkbox',
    'errorMessage',
    'otherErrorMessage',
  ];

  onSubmit(event) {
    if (!this.validateForm()) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  connect() {
    this.checkOtherReason();
  }

  onReasonChange() {
    this.clearErrors();
    this.checkOtherReason();
  }

  onOtherReasonInput() {
    this.clearErrors();
  }

  validateForm() {
    this.clearErrors();
    let isValid = true;

    if (!this.hasCheckedReason()) {
      this.showError(this.errorMessageTarget, this.reasonRequiredErrorValue);
      isValid = false;
    }

    if (this.isOtherReasonRequired() && this.otherReasonInputTarget.value.trim() === '') {
      this.showError(this.otherErrorMessageTarget, this.otherReasonRequiredErrorValue);
      isValid = false;
    }

    return isValid;
  }

  showError(element, message) {
    element.textContent = message;
    element.classList.remove('d-none');
  }

  clearErrors() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = '';
      this.errorMessageTarget.classList.add('d-none');
    }
    if (this.hasOtherErrorMessageTarget) {
      this.otherErrorMessageTarget.textContent = '';
      this.otherErrorMessageTarget.classList.add('d-none');
    }
  }

  checkOtherReason() {
    if (!this.hasOtherCheckboxTarget || !this.hasOtherReasonFieldTarget) return;

    const otherCheckbox = this.otherCheckboxTarget;
    const otherReasonField = this.otherReasonFieldTarget;
    const otherReasonInput = this.otherReasonInputTarget;

    if (otherCheckbox.checked) {
      otherReasonField.classList.remove('d-none');
      otherReasonInput.required = true;
    } else {
      otherReasonField.classList.add('d-none');
      otherReasonInput.required = false;
      otherReasonInput.value = '';
    }
  }

  getDeclineReasons() {
    const reasonIds = [];
    if (!this.hasCheckboxTarget) return reasonIds;
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox.checked) {
        reasonIds.push(checkbox.value);
      }
    });
    return reasonIds;
  }

  closeModal() {
    const modalElement = this.element.closest('.modal');
    if (!modalElement) {
      return;
    }

    const Modal = window.bootstrap?.Modal;
    if (!Modal) {
      console.error('Bootstrap Modal is not available on window object.');
      return;
    }

    const instance = Modal.getInstance(modalElement) ?? new Modal(modalElement);

    const handleHidden = () => {
      const remainingShownModals = document.querySelectorAll('.modal.show');
      if (remainingShownModals.length === 0) {
        document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove());
        document.body.classList.remove('modal-open');
      }
    };

    modalElement.addEventListener('hidden.bs.modal', handleHidden, { once: true });
    instance.hide();
  }

  getOtherReason() {
    if (this.hasOtherReasonInputTarget && this.isOtherReasonRequired()) {
      return this.otherReasonInputTarget.value.trim();
    }
    return '';
  }

  hasCheckedReason() {
    if (!this.hasCheckboxTarget) return false;
    return this.checkboxTargets.some(checkbox => checkbox.checked);
  }

  isOtherReasonRequired() {
    return this.hasOtherCheckboxTarget && this.otherCheckboxTarget.checked;
  }
}
